import React, {ChangeEvent, useState} from "react";
import logo from "../../../assets/img/logo.svg";
import { Button, StandaloneFormPage, Form } from "tabler-react";
import {Alerta} from "../../../utils/Alerta";
import {useAuth} from "../../../hooks/AuthContext";
import {useHistory} from "react-router-dom";

export function TwoFactorAuthForm() {
  const history = useHistory();
  const [code, setCode]= useState<string>()

  const { signIn, email, passwordTmp, store} = useAuth();

  async function handleLogin(email?: string, passwordTmp?: string, code?: string) {
    if (!passwordTmp || !email) {
      history.push("/");
      Alerta('Não foi possível autenticar.');
    }

    try {
      await signIn({
        email: email,
        password: passwordTmp,
        codeTotp: code ?? "",
      });

      if(!!store && !!store.id) {
        history.push('dashboard')
      }
    } catch (err) {
      Alerta("Login ou senha incorretos");
    }
  }

  return <StandaloneFormPage
    imageURL={logo}
    children={
      <Form
        onSubmit={(e) => {
          e.preventDefault()
          handleLogin()
        }}
        className="form-name"
      >
        <Form.Group label="Autenticação" className="form-reset">
          <Form.Input
            placeholder="Código 2FA"
            name="password"
            onChange={(event: ChangeEvent<HTMLInputElement>) => setCode(event.target.value)}
          />
        </Form.Group>

        <Button
          size="sm"
          href="#"
          RootComponent="a"
          color="primary"
          onClick={() => handleLogin(email, passwordTmp, code)}
          className="button-store"
          disabled={!code}
        >
          Login
        </Button>
      </Form>
    }
  />
}